// extracted by mini-css-extract-plugin
export default {"search-result-scrollable":"ItpMultitabSection_search-result-scrollable__MpQF7","searchResultScrollable":"ItpMultitabSection_search-result-scrollable__MpQF7"};